import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-381916ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "nft",
  class: "modal-window modal-window-squade"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Set slogan", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          title: "Close",
          class: "modal-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModalSlogan')))
        }, " × "),
        _hoisted_4,
        _createElementVNode("p", null, [
          _createElementVNode("input", {
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
            id: "input__text",
            type: "text",
            placeholder: "New slogan"
          }, null, 32)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('acceptSlogan'))),
            class: "button primary"
          }, "Accept")
        ])
      ])
    ])
  ]))
}